<template>
  <div>
    <UCEmptyList
      v-if="contracts.length === 0"
      :icon="iconContractOff"
      title=" Aún no hay contratos"
      subtitle=" Aún no se han creado contratos para esta finca"
    />
    <f7-list
      v-else
      media-list
    >
      <ul>
        <ContractItem
          v-for="contract in contracts"
          :key="contract.id"
          :contract="contract
          "
        />
      </ul>
    </f7-list>
  </div>
</template>

<script>
import UCEmptyList from '@/components/common/UCEmptyList.vue';
import icContractOff from '@/static/img/ic_contract_off.svg';
import ContractItem from './ContractItem.vue';

export default {
  name: 'ContractsList',
  components: { ContractItem, UCEmptyList },
  props: {
    contracts: { type: Array, default: () => [] },
  },

  computed: {
    iconContractOff: () => icContractOff,
  },

};
</script>
